import React from 'react'
import ReactDom from 'react-dom'

import './Popup.scss'
import classNames from 'classnames'

const Popup: React.FunctionComponent<{
  onClose: () => void
  style?: React.CSSProperties
  inline?: boolean
  fullscreen?: boolean
  children: React.ReactNode
}> = ({
  onClose,
  children,
  style,
  inline,
  fullscreen,
}) => {
  const popup = (
    <div
      className={classNames('Popup', { fullscreen })}
      onClick={e => {
        onClose()
        e.stopPropagation()
      }}
    >
      <div
        style={style}
        className="Popup-content"
        onClick={e => {
          e.stopPropagation()
        }}
      >
        {children}
      </div>
    </div>
  )

  if (inline) {
    return popup
  }

  return ReactDom.createPortal(
    popup,
    document.body
  )
}

export default Popup
